'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * model请求基础方法
 * Created by spring on 2018/8/21.
 */

/**
 * 把 url 地址简单的编码为字母和数字的字符串，作为缓存的key使用
 * @param url 接口请求地址，带参数的
 * @returns {*}
 */
var encode = exports.encode = function encode(url) {
  return url.replace(/(http|https|:|\.|\/|\?|&|=|#|,)/gi, '');
};

/**
 * 把url和params组合成？的参数url形式
 * @param url 接口请求地址
 * @param params 参数
 * @returns {string}
 */
var toUrlWithParams = exports.toUrlWithParams = function toUrlWithParams(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return '' + url + (url.indexOf('?') > 1 ? '&' : '?') + $.param(params);
};

/**
 * 获取以秒为单位的时间戳，用作缓存记录
 * @returns {number}
 */
var getTimestamp = exports.getTimestamp = function getTimestamp() {
  return Math.ceil(new Date().getTime() / 1000);
};